module.exports = __webpack_public_path__ + "img/SEJ_Eventos_lista desplegable.eac1263b.svg";